export default __webpack_public_path__ + "static/media/shopping-cart-empty.785f52a3.svg";